import { useState } from 'react';
import { Panel } from 'primereact/panel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterInput } from '../shared/FilterInput';

export const BannerProductoTable = ({ productos, loading, selectedCodigo, onSelect, disabled }) => {
    const [collapsed, setCollapsed] = useState(true);
    const selected = selectedCodigo != null ? productos.find(p => p.codigo === selectedCodigo) || null : null;

    const handleSelection = (e) => {
        onSelect(e.value?.codigo || null);
    };

    const headerTemplate = (options) => {
        const toggleIcon = options.collapsed ? 'pi pi-chevron-down' : 'pi pi-chevron-up';
        const hasSelection = selectedCodigo != null;
        return (
            <div className="flex align-items-center justify-content-between w-full cursor-pointer" onClick={options.onTogglerClick}>
                <div className="flex align-items-center gap-2">
                    <span className="font-bold text-lg">Producto</span>
                    {hasSelection && <span className="text-sm text-green-600 font-medium">({selected?.descripcion})</span>}
                </div>
                <span className={`${toggleIcon} text-500`} />
            </div>
        );
    };

    return (
        <Panel
            header="Producto"
            toggleable
            collapsed={collapsed}
            onToggle={(e) => setCollapsed(e.value)}
            headerTemplate={headerTemplate}
            className={selectedCodigo != null ? 'border-green-300' : ''}
        >
            <BannerProductoTableContent
                productos={productos}
                loading={loading}
                selected={selected}
                onSelectionChange={handleSelection}
                disabled={disabled}
            />
        </Panel>
    );
};

const BannerProductoTableContent = ({ productos, loading, selected, onSelectionChange, disabled }) => {
    const rows = [{ codigo: null, descripcion: '— Sin selección —' }, ...productos];

    return (
        <DataTable
            value={rows}
            selectionMode="single"
            selection={selected}
            onSelectionChange={onSelectionChange}
            dataKey="codigo"
            paginator
            rows={6}
            rowsPerPageOptions={[6, 10, 25]}
            scrollable
            scrollHeight="200px"
            loading={loading}
            emptyMessage="Sin productos"
            filterDisplay="row"
            filter
            tableStyle={{ minWidth: '100%' }}
            disabled={disabled}
        >
            <Column field="codigo" header="Código" sortable style={{ width: '30%' }} filter filterElement={FilterInput} bodyStyle={{ textAlign: 'center' }} />
            <Column field="descripcion" header="Descripción" sortable style={{ width: '70%' }} filter filterElement={FilterInput} />
        </DataTable>
    );
};
